import React from 'react'

// import { SiteContext } from 'context/site-context'

import cn from 'classnames'

// import {
//   getGeoFromLocalStorage,
//   getQS,
// } from 'helpers'

import './index.scss'

const ReviewSubmissionForm = props => {
  // const [ site, setSite ] = React.useContext(SiteContext)

  const [ state, setState ] = React.useState({
    author: '',
    title: '',
    review: '',
    errors: [],
    isSubmitting: false,
  })

  const handleInputChange = (key, value) => {
    setState({
      ...state,
      [key]: value,
      errors: state.errors.filter( field => field !== key ),
    })
  }

  const handleSubmit = React.useCallback( () => {
    const isValid = () => {
      let isValid = true
      let errors = []

      if(state.author.trim().length === 0){
        isValid = false
        errors.push('author')
      }

      if(state.title.trim().length === 0){
        isValid = false
        errors.push('title')
      }

      // if(state.review.trim().length < 20){
      if(state.review.trim().length === 0){
        isValid = false
        errors.push('review')
      }

      if(!isValid){
        setState({
          ...state,
          errors: errors,
        })
      }

      return isValid
    }

    if(isValid() && !state.isSubmitting) {
      // Handle submit.
      setState( prevState => ({
        ...prevState,
        isSubmitting: true,
      }))

      const payload = {
        imported_listing_id: props.listing?.id,
        body: state.review,
        creator: state.author,
        title: state.title,
      }

      try {
        fetch('https://api-blender.elocal.com/listing-processor/listings/reviews', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        })
        .then( response => {
          if(response.status !== 200){
            return {
              error: `We're sorry, but we coudn't save your review.  Please try again later.`
            }
          }
          return response.json()
        })
        .then( (data) => {
          if(data?.error){
            setState( prevState => ({
              ...prevState,
              submissionError: data.error,
              isSubmitting: false,
            }))
          } else {
            setState( prevState => ({
              ...prevState,
              isSubmitting: false,
              success: true,
            }))
          }
        }).catch( e => {
          setState( prevState => ({
            ...prevState,
            submissionError: 'We\'re sorry but there seems to be a problem.  Please try again later.',
            isSubmitting: false,
          }))
        })
      } catch(e) {
        setState( prevState => ({
          ...prevState,
          submissionError: 'We\'re sorry but there seems to be a problem.  Please try again later.',
          isSubmitting: false,
        }))
      }
    }
  }, [state, setState])

  const handleKeyDown = React.useCallback( e => {
    if(e.keyCode === 13) { // 'User pressed enter key')
      handleSubmit()
    }
  }, [handleSubmit])

  React.useEffect(() => {
    window.addEventListener('keydown', handleKeyDown)
    return () => {
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, [handleKeyDown])

  return <div className={`review-submission-form-container ${props.className || ''}`}>
    <fieldset className="panel-content">
      <h3>Submit a Review</h3>
      {state.success && <div className="success">
        <h4>Thanks!</h4>
        <p>Your review has been submitted.</p>
      </div>}
      {!state.success && <React.Fragment>
        <div className="row">
          <div className="input-container">
            <input
              className={cn({error: state.errors.indexOf('author') > -1})}
              type="text"
              placeholder="Your name..."
              value={state.author || ''}
              onChange={e => handleInputChange('author', e.target.value)} />
            {state.errors.indexOf('author') > -1 && <div className="error">Please enter your name.</div>}
          </div>
        </div>
        <div className="row">
          <div className="input-container">
            <input
              className={cn({error: state.errors.indexOf('title') > -1})}
              type="text"
              placeholder="Review title..."
              value={state.title || ''}
              onChange={e => handleInputChange('title', e.target.value)} />
            {state.errors.indexOf('title') > -1 && <div className="error">Please enter a review title.</div>}
          </div>
        </div>
        <div className="row">
          <div className="input-container">
            <textarea
              className={cn({error: state.errors.indexOf('review') > -1})}
              type="text"
              placeholder="Review (at least 20 characters)..."
              value={state.review || ''}
              onChange={e => handleInputChange('review', e.target.value)} />
            {state.errors.indexOf('review') > -1 && <div className="error">Please enter at least 20 characters.</div>}
          </div>
        </div>
        <div className="row submission-error-container error">
          {state.submissionError}
        </div>
        <div className="row action-container">
          <button className="button-trigger" onClick={() => handleSubmit()}>{state.isSubmitting ? 'Submitting...' : 'Submit'}</button>
        </div>
      </React.Fragment>}
    </fieldset>
  </div>
}

export default ReviewSubmissionForm
